import { useState } from 'react'
import { httpRequest } from '@calendly/http-tools'
import { MinimalButton } from '@calendly/ui/components/minimal-button'

import { useI18n } from 'locales'

import Header from './header'
import { SubmitButton, Input, SecondaryInformation } from './styles'

async function performLookup(email, setData, setErrors, setLoading, i18n) {
  if (!email) {
    setErrors([i18n.t('booking.templates.questions.errors.string.blank')])
    return null
  }

  setLoading(true)

  const [success, responseData] = await httpRequest({
    url: '/api/authentication/lookup',
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    data: {
      flow: 'invitee_login',
      lang: i18n.locale,
      email
    }
  })

  setLoading(false)
  if (success) {
    setData(responseData)
  } else {
    setErrors([responseData.message])
  }

  return null
}

export default ({ closePopup, setAuthenticationData }) => {
  const { i18n } = useI18n()
  const [errors, setErrors] = useState([])
  const [email, setEmail] = useState(null)
  const [loading, setLoading] = useState(false)
  return (
    <>
      <Header>{i18n.t('booking.mutual_availability.login.title')}</Header>
      <form
        noValidate
        onSubmit={(e) => { performLookup(email, setAuthenticationData, setErrors, setLoading, i18n); e.preventDefault() }}
      >
        <Input
          name="email"
          label="Email"
          type="email"
          onInput={(e) => setEmail(e.target.value)}
          onFocus={() => setErrors([])}
          error={errors?.[0]}
        />
        <SubmitButton loading={loading}>{i18n.t('booking.mutual_availability.continue')}</SubmitButton>
      </form>
      <SecondaryInformation>
        <div>
          {i18n.t('booking.mutual_availability.no_account')}
        </div>
        <div>
          <MinimalButton fontSize="medium" onClick={closePopup}>
            {i18n.t('booking.mutual_availability.login.no_worries_continue_scheduling')}
          </MinimalButton>
        </div>
      </SecondaryInformation>
    </>
  )
}
